<template>
<div class="chapter">
<div class="inner_page">
<p class="firstcenter"><i>For my wife, Carolyn,<br/>
  whose practice of genuine presence<br/>
  and embodied<br/>
  love knows no bounds</i></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// dedication.vue?0ef2f860